export default __webpack_public_path__ + "static/media/projectBig.21b06df4.png";